let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4l4CX")).then(() => parcelRequire('5WBO8'));